import { CalendarItemKind, CalendarSource } from '../../constants/calendar'
import {
  CalendarGridItemVariant,
  CalendarGridMode,
} from '../../constants/calendarGrid'

export const CALENDAR_ITEM_KIND_VARIANT = {
  [CalendarItemKind.appointment]: CalendarGridItemVariant.brand,
  [CalendarItemKind.followUp]: CalendarGridItemVariant.gold,
  [CalendarItemKind.taskDeadline]: CalendarGridItemVariant.green,
  [CalendarItemKind.taskGroup]: CalendarGridItemVariant.green,
}

export const CALENDAR_TASKS_SOURCES = [
  CalendarSource.followUp,
  CalendarSource.taskDeadline,
]

export const CALENDAR_TASKS_FILTERS = {
  include_cancelled_appointments: false,
  include_done_tasks: false,
  sources: CALENDAR_TASKS_SOURCES,
}

export const CALENDAR_PREFERENCES_INITIAL = {
  building: null,
  include_cancelled_appointments: false,
  include_done_tasks: false,
  sources: [
    CalendarSource.appointment,
    CalendarSource.followUp,
    CalendarSource.taskDeadline,
  ],
  view_mode: CalendarGridMode.week,
}

export const CALENDAR_LIST_SEPARATOR = ', '

export const CalendarItemStatusName = {
  archived: 'archived',
  cancelled: 'cancelled',
  done: 'done',
  due: 'due',
  open: 'open',
}

export const CALENDAR_ITEM_STATUS_PROPS = {
  [CalendarItemStatusName.archived]: {
    backgroundColor: 'var(--color-bg-selected)',
    text: 'Calendar.ArchivedKey',
    textColor: 'var(--secondary-text-color)',
  },
  [CalendarItemStatusName.cancelled]: {
    backgroundColor: 'var(--color-bg-selected)',
    text: 'Calendar.AppointmentStatusCancelledKey',
    textColor: 'var(--secondary-text-color)',
  },
  [CalendarItemStatusName.done]: {
    backgroundColor: 'var(--color-success-10)',
    text: 'Calendar.ChipDoneKey',
    textColor: 'var(--color-success)',
  },
  [CalendarItemStatusName.due]: {
    backgroundColor: 'var(--color-error-10)',
    text: 'Calendar.ChipDueKey',
    textColor: 'var(--color-error)',
  },
  [CalendarItemStatusName.open]: {
    backgroundColor: 'var(--color-in-progress-10)',
    text: 'Calendar.ChipOpenKey',
    textColor: 'var(--color-in-progress)',
  },
}

export const CALENDAR_DAY_LOAD_TAG_COLORS = {
  backgroundColor: 'var(--color-error-10)',
  textColor: 'var(--color-error)',
}

export const CALENDAR_NEXT_DAY_OFFSET = 1
